export const NAME = 'operators';

const CONTEXT = 'PDV::RECHARGE::OPERATORS';

const SERVICE_GET = `${CONTEXT}::SERVICE::GET`;

const UPDATE_FILTERS = `${CONTEXT}::UPDATE::FILTERS`;

const FETCH_START = `${CONTEXT}::FETCH::START`;
const FETCH_SUCCESS = `${CONTEXT}::FETCH::SUCCESS`;
const FETCH_ERROR = `${CONTEXT}::FETCH::ERROR`;

const RESET_STATE = `${CONTEXT}::RESET::STATE`;
const RESET_FILTERS = `${CONTEXT}::RESET::FILTERS`;

const UPDATE = {
  FILTERS: UPDATE_FILTERS,
};

const RESET = {
  STATE: RESET_STATE,
  FILTERS: RESET_FILTERS,
};

const SERVICE = {
  GET: SERVICE_GET,
};

const FETCH = {
  START: FETCH_START,
  SUCCESS: FETCH_SUCCESS,
  ERROR: FETCH_ERROR,
};

export const ACTION_TYPES = {
  RESET,
  SERVICE,
  FETCH,
  UPDATE,
};
